import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import OrgUnitAdminUserConstants from '../OrgUnitAdminUserConstants';
import NavLinks from '../../../meet/NavLinks';
import EntryNavLinks from '../../EntryNavLinks';
import MyMeetsNavLinks from '../../../myMeets/MyMeetsNavLinks';

import validate from './OrgUnitAdminRosterSecondaryRepValidation';

import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';
import useOmeMeetOrgUnitEntryData from '../../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useOmeMeetOrgUnitEntryInfoData from '../../../../state/omeMeetOrgUnitEntryInfo/UseOmeMeetOrgUnitEntryInfoData';
import useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData from '../../../../state/omeMeetOrgUnitAthleteEntryIndividualRosterEntry/UseOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData';
import useOmeMeetOrgUnitAthleteEntryData from '../../../../state/omeMeetOrgUnitAthleteEntry/UseOmeMeetOrgUnitAthleteEntryData';
import useOmeMeetOrgUnitNonAthleteEntryData from '../../../../state/omeMeetOrgUnitNonAthleteEntry/UseOmeMeetOrgUnitNonAthleteEntryData';
import useApprovedClubsForSecondaryRepData from '../../../../state/approvedClubsForSecondaryRep/UseApprovedClubsForSecondaryRepData';
import useAthleteSecondaryRepresentationData from '../../../../state/athleteSecondaryRepresentation/UseAthleteSecondaryRepresentationData';
import useOUAdminEntryContextData from '../../../../state/ouAdminEntryContextView/UseOUAdminEntryContextData';
import useOmeMeetOrgUnitEntryTimesData from '../../../../state/omeMeetOrgUnitEntryTimes/UseOmeMeetOrgUnitEntryTimesData';
import useMyMeetsFiltersData from '../../../../state/myMeetsFilters/UseMyMeetsFiltersData';
import useOmeMeetOrgUnitEntryRosterPermissionsData from '../../../../state/omeMeetOrgUnitEntryRosterPermissions/UseOmeMeetOrgUnitEntryRosterPermissionsData';

import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';
import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import UseForm from '@usas/ui-web/utils/UseForm';
import Constants from '@usas/ui-web/utils/Constants';
import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import { rosterEntriesIsComplete } from '../../../../components/leftNavigationOmeTeamEntry/LeftNavValidation';

const INITIAL_MODAL_STATE = {
  displayPopUp: false,
  modalTitle: 'Delete Athlete from Roster?',
  athleteName: '',
  competitionCategory: '',
  birthDate: '',
  ageAtMeet: '',
  status: '',
  isRelayOnlyAthlete: '',
  orgUnitAthleteEntryId: Constants.DEFAULT_ID
};

const SECONDARY_REP_INITIAL_MODAL_STATE = {
  displayPopUp: false,
  modalTitle: "Athlete's Secondary Representation",
  athleteName: '',
  competitionCategory: '',
  birthDate: '',
  ageAtMeet: '',
  status: '',
  isRelayOnlyAthlete: '',
  orgUnitAthleteEntryId: Constants.DEFAULT_ID,
  athleteSecondaryRepresentationId: Constants.DEFAULT_ID,
  secondaryOrgUnitId: Constants.DEFAULT_ID,
  secondaryOrgUnitName: ''
};

const INITIAL_FORM_STATE = {
  secondaryOrgUnitId: Constants.DEFAULT_ID,
  secondaryOrgUnitName: '',
  teamOrgUnitId: Constants.DEFAULT_ID
};

const useOrgUnitAdminRosterEntries = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { omeMeetState } = useOmeMeetData();
  const { omeMeetOrgUnitEntryState } = useOmeMeetOrgUnitEntryData();
  const { omeMeetOrgUnitEntryInfoState, getOmeMeetOrgUnitEntryInfo } = useOmeMeetOrgUnitEntryInfoData();
  const { omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, getOrgUnitAthleteEntryIndividualRosterEntryByOmeMeetOrgUnitEntryId }
    = useOmeMeetOrgUnitAthleteEntryIndividualRosterEntryData();
  const { omeMeetOrgUnitAthleteEntryState, getOrgUnitAthleteEntryRoster, deleteOrgUnitAthleteEntry } = useOmeMeetOrgUnitAthleteEntryData();
  const { omeMeetOrgUnitNonAthleteEntryState, getOrgUnitNonAthleteEntryCredentials } = useOmeMeetOrgUnitNonAthleteEntryData();
  const { approvedClubsForSecondaryRepState, getApprovedClubsForSecondaryRep } = useApprovedClubsForSecondaryRepData();
  const { athleteSecondaryRepresentationState, postAthleteSecondaryRepresentation, deleteAthleteSecondaryRepresentation } = useAthleteSecondaryRepresentationData();
  const { omeMeetOrgUnitEntryTimesState, putOmeMeetOrgUnitEntryTimes, confirmSaveOmeMeetOrgUnitEntryTimes } = useOmeMeetOrgUnitEntryTimesData();
  const { omeMeetOrgUnitEntryRosterPermissionsState } = useOmeMeetOrgUnitEntryRosterPermissionsData();
  const { oUAdminEntryContextState } = useOUAdminEntryContextData();
  const { ATHLETE_INDIVIDUAL_EVENT_ENTRY_OME_FEE_TYPE_ID, ATHLETE_INDIVIDUAL_BONUS_EVENT_ENTRY_OME_FEE_TYPE_ID } = useEnvironmentVariableData();
  const { searchMeetState, setSearchMeetState } = useSearchMeetData();
  const { selectOrgUnitState } = useSelectOrgUnitData();
  const { myMeetsFiltersState } = useMyMeetsFiltersData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const [modalState, setModalState] = useState(INITIAL_MODAL_STATE);
  const [secondaryRepModalState, setSecondaryRepModalState] = useState(SECONDARY_REP_INITIAL_MODAL_STATE);
  const [state, setState] = useState({ tryGet: false, submitButton: '', tryRedirect: false, error: '' });
  const [gridState, setGridState] = useState({ gridData: [], showUpdateButton: false, onlyShowAthletesRequiringEventApproval: false });
  const { handleSubmit, formState, errorState, onValueTextPairChanged, setFormData, setErrors } = UseForm(INITIAL_FORM_STATE, submitFormCallback, validate);

  const onAddAthlete = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (omeMeetState.route === '') {
      //OME Route
      navigate(EntryNavLinks.OU_ADMIN_ROSTER_SELECTION);
    }
    else {
      //Meet Route
      navigate(NavLinks.OU_ADMIN_ROSTER_SELECTION);
    }
  };

  const onEditAthleteClicked = (e, athlete) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (omeMeetState.route === '') {
      //OME Route
      navigate(EntryNavLinks.OU_ADMIN_ROSTER_ENTRIES_DETAIL, { state: { athlete } });
    }
    else {
      //Meet Route
      navigate(NavLinks.OU_ADMIN_ROSTER_ENTRIES_DETAIL, { state: { athlete } });
    }
  };

  const onDeleteAthleteClicked = (e, athlete) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState({
      ...modalState,
      displayPopUp: true,
      athleteName: (athlete.firstName || athlete.middleName || athlete.lastName) ? `${athlete.firstName || ''} ${athlete.preferredName !== '' && athlete.preferredName !== athlete.firstName ? '"' + athlete.preferredName + '"' : ''} ${athlete.middleName || ''} ${athlete.lastName || ''}` : '',
      competitionCategory: athlete.competitionGenderTypeName || '',
      birthDate: athlete.birthDate ? formatDate(athlete.birthDate) : '',
      ageAtMeet: athlete.ageAtMeet >= 0 && athlete.ageAtMeet !== null ? athlete.ageAtMeet : '',
      status: athlete.status || '',
      isRelayOnlyAthlete: athlete.isRelayOnlyAthlete === true ? 'Yes' : athlete.isRelayOnlyAthlete === false ? 'No' : '',
      orgUnitAthleteEntryId: athlete.orgUnitAthleteEntryId || Constants.DEFAULT_ID
    });
  };

  const onModalCanceled = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setModalState(INITIAL_MODAL_STATE);
  };

  const onDeleteAthlete = (e, orgUnitAthleteEntryId) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    deleteOrgUnitAthleteEntry(orgUnitAthleteEntryId);
    onModalCanceled();
    setState({ ...state, tryGet: true, error: '' });
  };

  const onAddSecondaryRepToAthleteClicked = (e, athlete) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setSecondaryRepModalState({
      ...secondaryRepModalState,
      displayPopUp: true,
      athleteName: (athlete.firstName || athlete.middleName || athlete.lastName) ? `${athlete.firstName || ''} ${athlete.preferredName !== '' && athlete.preferredName !== athlete.firstName ? '"' + athlete.preferredName + '"' : ''} ${athlete.middleName || ''} ${athlete.lastName || ''}` : '',
      competitionCategory: athlete.competitionGenderTypeName || '',
      birthDate: athlete.birthDate ? formatDate(athlete.birthDate) : '',
      ageAtMeet: athlete.ageAtMeet >= 0 && athlete.ageAtMeet !== null ? athlete.ageAtMeet : '',
      status: athlete.status || '',
      isRelayOnlyAthlete: athlete.isRelayOnlyAthlete === true ? 'Yes' : athlete.isRelayOnlyAthlete === false ? 'No' : '',
      orgUnitAthleteEntryId: athlete.orgUnitAthleteEntryId || Constants.DEFAULT_ID,
      athleteSecondaryRepresentationId: athlete.athleteSecondaryRepresentationId || Constants.DEFAULT_ID,
      secondaryOrgUnitId: athlete.secondaryRepresentationOrgUnitId || Constants.DEFAULT_ID,
      secondaryOrgUnitName: athlete.secondaryRepresentationOrgUnitId ? `${athlete.secondaryRepresentationOrgUnitName || ''} (${athlete.secondaryRepresentationParentOrgUnitCode || ''}/${athlete.secondaryRepresentationOrgUnitCode || ''})` : ''
    });
  };

  const onSaveSecondaryOrgUnitRepresentation = (secondaryOrgUnitId, orgUnitAthleteEntryId, athleteSecondaryRepresentationId) => {
    if (secondaryRepModalState.displayPopUp === true) {
      if ((secondaryOrgUnitId !== Constants.DEFAULT_ID) && (secondaryOrgUnitId !== secondaryRepModalState.secondaryOrgUnitId)) {
        postAthleteSecondaryRepresentation({ secondaryOrgUnitId: secondaryOrgUnitId, orgUnitAthleteEntryId: orgUnitAthleteEntryId });
        setState({ ...state, tryGet: true });
        setErrors({});
        setSecondaryRepModalState(SECONDARY_REP_INITIAL_MODAL_STATE);
      } else if (secondaryOrgUnitId === Constants.DEFAULT_ID && athleteSecondaryRepresentationId !== Constants.DEFAULT_ID) {
        deleteAthleteSecondaryRepresentation(athleteSecondaryRepresentationId);
        setState({ ...state, tryGet: true });
        setErrors({});
        setSecondaryRepModalState(SECONDARY_REP_INITIAL_MODAL_STATE);
      } else {
        onSecondaryRepModalCanceled();
      }
    }
  };

  const onSecondaryRepModalCanceled = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setErrors({});
    setState({ ...state, tryGet: false });
    setSecondaryRepModalState(SECONDARY_REP_INITIAL_MODAL_STATE);
  };

  const onNextButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: OrgUnitAdminUserConstants.CONTINUE, tryRedirect: true, error: '' });
  };

  const onSaveAndExitButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: OrgUnitAdminUserConstants.SAVE_AND_EXIT, tryRedirect: true, error: '' });
  };

  const onBackButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: OrgUnitAdminUserConstants.BACK, tryRedirect: true, error: '' });
  };

  const onUpdateAthleteTimes = (e, athlete) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    putOmeMeetOrgUnitEntryTimes(omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId, athlete.orgUnitAthleteEntryId);
    setState({ ...state, tryGet: true });
  };

  const onUpdateRosterTimes = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    putOmeMeetOrgUnitEntryTimes(omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId);
    setState({ ...state, tryGet: true });
  };

  function onFilterGridClicked(gridState) {
    let filteredGridData = [];
    let showUpdateButton = false;

    const omeMeetOrgUnitAthleteEntryArrayCopy = JSON.parse(JSON.stringify(omeMeetOrgUnitAthleteEntryState.arrayData));
    if (gridState.onlyShowAthletesRequiringEventApproval === true) {
      filteredGridData = omeMeetOrgUnitAthleteEntryArrayCopy.filter((athlete) => athlete.status === Constants.WORKFLOW_STATUS_EVENT_APPROVAL_REQUIRED)
    }
    else if (gridState.onlyShowAthletesRequiringEventApproval === false) {
      filteredGridData = omeMeetOrgUnitAthleteEntryArrayCopy;
    }

    if (filteredGridData?.find(athlete => athlete?.events?.length > 0)) {
      if (omeMeetState.objData?.omeMeetPrice?.length > 0) {
        const hasCostPerAthleteIndividualEventEntry = omeMeetState.objData?.omeMeetPrice.find(x => x.omeFeeTypeId === ATHLETE_INDIVIDUAL_EVENT_ENTRY_OME_FEE_TYPE_ID)?.amount !== (null || undefined) ? true : false;
        const hasCostPerAthleteIndividualBonusEventEntry = omeMeetState.objData?.omeMeetPrice.find(x => x.omeFeeTypeId === ATHLETE_INDIVIDUAL_BONUS_EVENT_ENTRY_OME_FEE_TYPE_ID)?.amount !== (null || undefined) ? true : false;
        if (hasCostPerAthleteIndividualEventEntry === true && hasCostPerAthleteIndividualBonusEventEntry === true) {
          //if Individual Event Cost equals Bonus Event Cost, then show the update times button
          if (omeMeetState.objData?.omeMeetPrice.find(x => x.omeFeeTypeId === ATHLETE_INDIVIDUAL_EVENT_ENTRY_OME_FEE_TYPE_ID)?.amount ===
            omeMeetState.objData?.omeMeetPrice.find(x => x.omeFeeTypeId === ATHLETE_INDIVIDUAL_BONUS_EVENT_ENTRY_OME_FEE_TYPE_ID)?.amount) {
            showUpdateButton = true;
          }
        }
        //if we don't have both Individual and Bonus Event prices for the meet, then show the update times button
        else {
          showUpdateButton = true;
        }
      }
      //if we don't have pricing for the meet, then show the update times button
      else {
        showUpdateButton = true;
      }
    }

    setGridState({ ...gridState, gridData: filteredGridData, showUpdateButton: showUpdateButton });
  }

  function submitFormCallback() {
    onSaveSecondaryOrgUnitRepresentation(formState.secondaryOrgUnitId, secondaryRepModalState.orgUnitAthleteEntryId, secondaryRepModalState.athleteSecondaryRepresentationId);
  }

  useEffect(() => {
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (location.state && location.state?.tryGet === true) {
      setState({ ...state, tryGet: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (secondaryRepModalState.displayPopUp === true && approvedClubsForSecondaryRepState.isArrayLoading === false) {
      if (approvedClubsForSecondaryRepState.items === undefined) {
        getApprovedClubsForSecondaryRep();
      }
      else {
        setFormData({ ...formState, secondaryOrgUnitId: secondaryRepModalState.secondaryOrgUnitId || Constants.DEFAULT_ID, secondaryOrgUnitName: secondaryRepModalState.secondaryOrgUnitName || '', teamOrgUnitId: omeMeetOrgUnitEntryState.objData.orgUnitId }, true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondaryRepModalState.displayPopUp, approvedClubsForSecondaryRepState])

  useEffect(() => {
    if (omeMeetOrgUnitEntryTimesState.isSaved === true) {
      confirmSaveOmeMeetOrgUnitEntryTimes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitEntryTimesState.isSaved])

  useEffect(() => {
    if (omeMeetOrgUnitEntryState.isObjLoaded === true && omeMeetOrgUnitEntryState?.objData?.omeMeetOrgUnitEntryId &&
      omeMeetOrgUnitAthleteEntryState.isSaving === false && athleteSecondaryRepresentationState.isSaving === false && omeMeetOrgUnitEntryTimesState.isSaving === false) {
      if ((omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoaded === false || omeMeetOrgUnitAthleteEntryState.isArrayLoaded === false || state.tryGet === true) &&
        omeMeetOrgUnitAthleteEntryIndividualRosterEntryState.isArrayLoading === false && omeMeetOrgUnitAthleteEntryState.isArrayLoading === false && omeMeetOrgUnitNonAthleteEntryState.isArrayLoading === false) {
        getOrgUnitAthleteEntryIndividualRosterEntryByOmeMeetOrgUnitEntryId(omeMeetOrgUnitEntryState?.objData.omeMeetOrgUnitEntryId);
        //Make sure to update roster & credentials & info whenever roster entries changes
        getOrgUnitAthleteEntryRoster(omeMeetOrgUnitEntryState?.objData.omeMeetOrgUnitEntryId);
        getOrgUnitNonAthleteEntryCredentials(omeMeetOrgUnitEntryState?.objData.omeMeetOrgUnitEntryId);
        getOmeMeetOrgUnitEntryInfo(omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId);
        if (state.tryGet === true) {
          setState({ ...state, tryGet: false, error: '' });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitEntryState, omeMeetOrgUnitAthleteEntryIndividualRosterEntryState, omeMeetOrgUnitAthleteEntryState, omeMeetOrgUnitNonAthleteEntryState, athleteSecondaryRepresentationState, omeMeetOrgUnitEntryTimesState, state.tryGet])

  useEffect(() => {
    if (omeMeetOrgUnitAthleteEntryState.isArrayLoaded === true &&
      omeMeetOrgUnitAthleteEntryState.isArrayLoading === false &&
      (gridState.onlyShowAthletesRequiringEventApproval === true || gridState.onlyShowAthletesRequiringEventApproval === false)) {
      onFilterGridClicked(gridState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitAthleteEntryState.isArrayLoaded, omeMeetOrgUnitAthleteEntryState.isArrayLoading, gridState.onlyShowAthletesRequiringEventApproval])

  useEffect(() => {
    if (omeMeetOrgUnitAthleteEntryState.isSaving === false && omeMeetOrgUnitEntryTimesState.isSaving === false && state.tryRedirect === true) {
      if (state.submitButton === OrgUnitAdminUserConstants.CONTINUE) {
        if (rosterEntriesIsComplete(omeMeetOrgUnitEntryInfoState.objData) === false) {
          let error = '';
          if (omeMeetOrgUnitEntryInfoState.objData?.hasRosterAthlete === false) {
            error = 'At least one athlete must be on the roster';
          }
          if (omeMeetOrgUnitEntryInfoState.objData?.rosterAthleteCountAllowed === false) {
            if (omeMeetOrgUnitEntryInfoState.objData?.maxNumberOfAthletesForMeet) {
              error = error ? error + `\n\n The current roster exceeds the max number of athletes allowed for the meet: ${omeMeetOrgUnitEntryInfoState.objData?.maxNumberOfAthletesForMeet} ${omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === true ? (omeMeetOrgUnitEntryInfoState.objData?.includeRelayOnlySwimmersInMaxNumber === true ? `(includes Relay Only Swimmers)` : `(excludes Relay Only Swimmers)`) : ``}` :
                `The current roster exceeds the max number of athletes allowed for the meet: ${omeMeetOrgUnitEntryInfoState.objData?.maxNumberOfAthletesForMeet} ${omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === true ? (omeMeetOrgUnitEntryInfoState.objData?.includeRelayOnlySwimmersInMaxNumber === true ? `(includes Relay Only Swimmers)` : `(excludes Relay Only Swimmers)`) : ``}`;
            }
            else {
              error = error ? error + `\n\n The current roster exceeds the max number of athletes allowed for the meet ${omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === true ? (omeMeetOrgUnitEntryInfoState.objData?.includeRelayOnlySwimmersInMaxNumber === true ? `(includes Relay Only Swimmers)` : `(excludes Relay Only Swimmers)`) : ``}` :
                `The current roster exceeds the max number of athletes allowed for the meet ${omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === true ? (omeMeetOrgUnitEntryInfoState.objData?.includeRelayOnlySwimmersInMaxNumber === true ? `(includes Relay Only Swimmers)` : `(excludes Relay Only Swimmers)`) : ``}`;
            }
          }
          if (omeMeetOrgUnitEntryInfoState.objData?.hasApprovedEvents === false) {
            error = error ? error + `\n\n All athletes on the roster must have a status of 'Events Approved' ${omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === true ? "or 'Relay Only Swimmer'" : omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === false ? "('Relay Only Swimmer' status is not allowed)" : ''}` :
              `All athletes on the roster must have a status of 'Events Approved' ${omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === true ? "or 'Relay Only Swimmer'" : omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === false ? "('Relay Only Swimmer' status is not allowed)" : ''}`
          }
          setState({
            ...state, tryRedirect: false, submitButton: '', error: error
          });
        }
        else {
          if (omeMeetState.route !== '') {
            navigate(NavLinks.OU_ADMIN_RELAY_ENTRIES);
          }
          else {
            navigate(EntryNavLinks.OU_ADMIN_RELAY_ENTRIES);
          }
        }
      }
      else if (state.submitButton === OrgUnitAdminUserConstants.SAVE_AND_EXIT) {
        if (omeMeetState.route !== '') {
          setSearchMeetState({ ...searchMeetState, showMeetHeader: true });
          navigate(NavLinks.MEET_ENTRY_TEAM, { state: { tryGetOmeMeet: true } });
        }
        else {
          navigate(MyMeetsNavLinks.MEET_ENTRY_TEAM, { state: { selectOrgUnitState: selectOrgUnitState, myMeetsFiltersState: myMeetsFiltersState } });
        }
      }
      else if (state.submitButton === OrgUnitAdminUserConstants.BACK) {
        if (omeMeetState.route !== '') {
          navigate(NavLinks.OU_ADMIN_MEET_INFO);
        }
        else {
          navigate(EntryNavLinks.OU_ADMIN_MEET_INFO);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitAthleteEntryState.isSaving, omeMeetOrgUnitEntryTimesState.isSaving, state, omeMeetOrgUnitEntryInfoState.objData]);

  return {
    oUAdminEntryContextState,
    omeMeetOrgUnitEntryTimesState,
    omeMeetOrgUnitEntryInfoState,
    state,
    location,
    gridState,
    setGridState,
    omeMeetOrgUnitAthleteEntryIndividualRosterEntryState,
    omeMeetOrgUnitAthleteEntryState,
    approvedClubsForSecondaryRepState,
    athleteSecondaryRepresentationState,
    formState,
    errorState,
    handleSubmit,
    onValueTextPairChanged,
    onAddAthlete,
    onEditAthleteClicked,
    onDeleteAthleteClicked,
    onDeleteAthlete,
    onAddSecondaryRepToAthleteClicked,
    onUpdateAthleteTimes,
    onUpdateRosterTimes,
    onNextButtonClicked,
    onSaveAndExitButtonClicked,
    onBackButtonClicked,
    modalState,
    onModalCanceled,
    secondaryRepModalState,
    onSecondaryRepModalCanceled,
    omeMeetOrgUnitEntryRosterPermissionsState
  };
}

export default useOrgUnitAdminRosterEntries;